












import {MetaInfo} from 'vue-meta'
import {Component, Vue} from 'vue-property-decorator'
import {$, ToastConfig} from 'simpli-web-sdk'
import ModalDialog from '@/components/modals/ModalDialog.vue'

const metaInfo = (): MetaInfo => ({
  title: $.t('app.subtitle') as string,
  titleTemplate: `%s | ${$.t('app.title')}`,
})

@Component({
  metaInfo,
  components: {ModalDialog},
})
export default class App extends Vue {
  get toastStyle() {
    return ToastConfig.ToastDefaultStyle
  }

  created() {
    this.$auth.populateToken()
  }
}
